import { render, staticRenderFns } from "./HouseProfileComponent.vue?vue&type=template&id=efedb7fe&scoped=true&"
import script from "./HouseProfileComponent.vue?vue&type=script&lang=js&"
export * from "./HouseProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./HouseProfileComponent.vue?vue&type=style&index=0&id=efedb7fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efedb7fe",
  null
  
)

export default component.exports